/* eslint-disable @typescript-eslint/ban-ts-comment */

import { get } from 'lodash'
import gql from 'graphql-tag'
import moment from 'moment'
import client from '@stores/apollo'
import { INewLease, ILease, IEmployee } from '@api'
import { parseContract } from '.'
import { LeaseFragment } from '@api/fragments'
import { SERVER_DATE_FMT } from '@constants'

interface IPromise {
  lease: ILease
}
export default function create(lease: ILease | INewLease): Promise<IPromise> {
  if (lease.metadata) {
    for (const [k, v] of Object.entries(lease.metadata)) {
      // @ts-ignore
      if (v === '') delete lease.metadata[k]
    }
  }

  let mutation
  const input = {
    id: lease.id,
    cost: lease.cost + '',
    floorId: get(lease, 'floor.id'),
    buildingId: get(lease, 'building.id'),
    name: lease.name,
    notes: lease.notes,
    endAlert: Boolean(lease.endAlert),
    noticeAlert: Boolean(lease.noticeAlert),
    reminderAlert: Boolean(lease.reminderAlert),
    effectiveAlert: Boolean(lease.effectiveAlert),
    owner: lease.owner,
    title: lease.title,
    contactInfo: lease.contactInfo,
    contactName: lease.contactName,
    metadata: JSON.stringify(lease.metadata || {}),
    employeeIds: lease.id ? lease.employees.map((e: IEmployee) => e.id) : undefined,
  }
  for (const field of ['endDate', 'noticeDate', 'startDate', 'reminderDate', 'effectiveDate']) {
    // @ts-ignore
    input[field] = lease[field] ? moment(lease[field]).format(SERVER_DATE_FMT) : null
  }

  if (lease.id) {
    mutation = updateMutation
  } else {
    mutation = createMutation
    // @ts-ignore
    input.type = 'Lease'
  }

  return client.gql
    .mutate({
      mutation,
      variables: { input },
    })
    .then(({ data }: any) => {
      let lease = get(data, 'createContract.contract') || get(data, 'updateContract.contract')
      lease = parseContract(lease)
      return { lease }
    })
}

interface IMutatePayload {
  data: {
    createContract?: ILease
    updateContract?: ILease
  }
}

const createMutation = gql`
  mutation createContract($input: CreateContractInput!) {
    createContract(input: $input) {
      contract {
        ...LeaseFragment
      }
    }
  }
  ${LeaseFragment}
`

const updateMutation = gql`
  mutation updateContract($input: UpdateContractInput!) {
    updateContract(input: $input) {
      contract {
        ...LeaseFragment
      }
    }
  }
  ${LeaseFragment}
`
